module.exports = __webpack_public_path__ + "img/compensation.f4d397fb.svg";